export default __webpack_public_path__ + "static/media/Voting.909dac07.png";